import { ReactElement } from 'react';

import { NumberFormatter } from '@Components/NumberFormatter/NumberFormatter';

// "ip frequency" rows store an average count in the ratio column; every other check stores a
// percentage alongside the monitored / total counts it was computed from.
export const renderRatio = (
  isIpFrequency: boolean,
  ratio: number | null,
  monitored: string | null,
  total: string | null
): ReactElement | string => {
  if (isIpFrequency) {
    return <NumberFormatter value={ratio} type='#2' />;
  }
  if (!ratio) {
    return '-';
  }
  return (
    <div>
      <NumberFormatter value={ratio / 100} type='%' decimals={1} /> (
      <NumberFormatter value={Number(monitored)} type='#' /> /{' '}
      <NumberFormatter value={Number(total)} type='#' />)
    </div>
  );
};
